import { useState } from 'react'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

interface CancelLeaseDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  contractNumber: string
  onConfirm: (params: { cancellation_reason?: string }) => void
  isPending: boolean
}

export function CancelLeaseDialog({
  open,
  onOpenChange,
  contractNumber,
  onConfirm,
  isPending,
}: CancelLeaseDialogProps) {
  const [reason, setReason] = useState('')

  function handleConfirm() {
    onConfirm({ cancellation_reason: reason.trim() || undefined })
  }

  function handleOpenChange(next: boolean) {
    if (!next) setReason('')
    onOpenChange(next)
  }

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Lease</AlertDialogTitle>
          <AlertDialogDescription>
            Cancel draft lease{' '}
            <span className="font-mono font-semibold">{contractNumber}</span>?
            This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="space-y-2 py-2">
          <Label htmlFor="cancel-reason">Reason (optional)</Label>
          <Textarea
            id="cancel-reason"
            placeholder="e.g. Client withdrew, duplicate entry…"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={2}
          />
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Keep Lease</AlertDialogCancel>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending ? 'Cancelling…' : 'Cancel Lease'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
